export default __webpack_public_path__ + "static/media/demonslayer.a5c95c97.mp3";